import DefaultFormTemplate from './DefaultFormTemplate.component';
import TextModeFormTemplate from './TextModeFormTemplate.component';

export { DefaultFormTemplate, TextModeFormTemplate };
